import { makeAutoObservable, runInAction } from 'mobx';
import { RootStore } from 'store/rootStore';
import { RateSegment } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import { Cart } from 'types/cartServiceV2';
import { DefaultFormFields, FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';

interface SaveProposalFields extends DefaultFormFields {
  name: FormControl<string>;
}

export class FavoriteProposalsStore {
  rootStore: RootStore;
  loading = false;
  renameLoading = false;
  filter: RateSegment | 'ALL' = 'ALL';
  carts: Cart[] = [];
  isWarningModalOpen = false;
  isSaveModalOpen = false;
  currentCartId = '';
  saveForm: FormController<SaveProposalFields>;

  private setLoading(status: boolean): void {
    this.loading = status;
  }

  private setRenameLoading(status: boolean): void {
    this.renameLoading = status;
  }

  public openWarningModal(cartId: string): void {
    this.isWarningModalOpen = true;
    this.currentCartId = cartId;
  }

  public closeWarningModal(): void {
    this.isWarningModalOpen = false;
    this.currentCartId = '';
  }

  openRenameTemplateModal(name: string, cartId = ''): void {
    this.currentCartId = cartId;
    this.isSaveModalOpen = true;
    this.saveForm.populateFields({ name });
  }

  closeRenameTemplateModal(): void {
    this.currentCartId = '';
    this.isSaveModalOpen = false;
    this.saveForm.resetForm();
  }

  async renameProposal(): Promise<void> {
    this.setRenameLoading(true);
    const res = await this.rootStore.cartStoreV2.updateCartName(this.currentCartId, this.saveForm.fields.name.value);
    runInAction(() => {
      if (res.data?.updateCartName) {
        this.setRenameLoading(false);
      }
    });
  }

  public updateFilter(filter: RateSegment | 'ALL'): void {
    this.filter = filter;
  }

  public async getCartsByRateSegment(rateSegment: RateSegment | 'ALL'): Promise<void> {
    this.setLoading(true);
    const res = await this.rootStore.cartStoreV2.getBrokerCartsByRateSegment(
      rateSegment === 'ALL' ? undefined : rateSegment,
    );
    runInAction(() => {
      this.carts = res.data?.getBrokerCartsBySegment || [];
      this.setLoading(false);
    });
  }

  public async deleteCart(): Promise<void> {
    this.setLoading(true);
    const res = await this.rootStore.cartStoreV2.deleteCart(this.currentCartId);
    runInAction(() => {
      if (res.data?.deleteCart) {
        void this.getCartsByRateSegment(this.filter);
      }
      this.setLoading(false);
    });
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    this.saveForm = new FormController({
      name: new FormControl<string>('', { optional: false }),
    });

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
